var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.componentToUse,{tag:"component",attrs:{"current":_vm.current,"available":_vm.available,"editor-store-path":_vm.editorStorePath},on:{"modifyAvailableLanguages":function($event){return _vm.$emit('modifyAvailableLanguages', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }